import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsSprinter() {
  const { user } = useAuth();
  const [isSprinter, setIsSprinter] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!user) {
      setIsSprinter(false);
      setLoading(false);
      return;
    }
    (async () => {
      const { data } = await supabase
        .from("sprinters")
        .select("id")
        .eq("user_id", user.id)
        .maybeSingle();
      if (!cancelled) {
        setIsSprinter(!!data);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  return { isSprinter, loading };
}
